import React from 'react';
import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Logo & description */}
        <div className="footer-col">
          <h2 className="footer-logo">Orbit Energy</h2>
          <p className="footer-text">
            Your trusted partner in efficient electricity, gas, and water solutions.
          </p>
          {/* <div className="trustpilot-link-footer">
            <a 
              href="https://www.trustpilot.com/review/orbitenergy.solutions" 
              target="_blank" 
              rel="noreferrer"
            >
              Review us on <span className="star">★</span> Trustpilot
            </a>
          </div> */}
        </div>

        {/* Navigation Links */}
        <div className="footer-col">
          <h3>Pages</h3>
          <ul className="footer-links">
            <li className='foot-links'><Link to="/#">Home</Link></li>
            {/* <li className='foot-links'><Link href="/services">Services</Link></li>
            <li className='foot-links'><Link href="/benefits">Benefits</Link></li>
            <li className='foot-links'><Link href="/about">About Us</Link></li> */}
            <li className='foot-links'><Link to="/Contacts">Contact</Link></li>
            <li className='foot-links'><Link to="/Complains">Complaints Procedure</Link></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-col">
          <h3>Contact</h3>
          <p>Email: info@orbitenergy.solutions</p>
          <p>Phone: 0330 058 1634</p>
        </div>

        {/* Social Icons */}
        <div className="footer-col">
          <h3>Follow Us</h3>
          <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 Orbit Energy. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
